import { render, staticRenderFns } from "./inviteFriend.vue?vue&type=template&id=e72c3014&scoped=true&"
import script from "./inviteFriend.vue?vue&type=script&lang=js&"
export * from "./inviteFriend.vue?vue&type=script&lang=js&"
import style0 from "./inviteFriend.vue?vue&type=style&index=0&id=e72c3014&scoped=true&lang=css&"
import style1 from "./inviteFriend.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e72c3014",
  null
  
)

export default component.exports